import mutations from './mutations';
import api from '../api';

export default {
  namespaced: true,
  state: {
    loading: false,
    entities: []
  },
  mutations: {
    [mutations.LOADING](state) {
      state.loading = true;
    },
    [mutations.LOADED](state) {
      state.loading = false;
    }
  },
  actions: {
    getAll({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.position
        .getAll(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          console.log(error);
          commit(mutations.LOADED);
          return error;
        });
    },
    create({ commit }, payload) {
      commit(mutations.LOADING);
      return api.position
        .create(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    detail({ commit }, id) {
      commit(mutations.LOADING);
      return api.position
        .detail(id)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    update({ commit }, { id, params }) {
      commit(mutations.LOADING);
      return api.position
        .update(id, params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          console.log('error', err);
          commit(mutations.LOADED);
          return err;
        });
    },
    delete({ commit }, id) {
      commit(mutations.LOADING);
      return api.position
        .delete(id)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    }
  },
  getters: {}
};
